export default "__VITE_ASSET__9c47f278__"